import {
  Component,
  OnInit,
  ChangeDetectorRef
} from '@angular/core';

import {
  CommonModule
} from '@angular/common';

import {
  RouterLink,
  RouterLinkActive
} from '@angular/router';

import {
  HttpClient
} from '@angular/common/http';

@Component({
  selector: 'app-home',
  standalone: true,
  imports: [
    CommonModule,
    RouterLink,
    RouterLinkActive
  ],
  templateUrl: './home.html',
  styleUrls: ['./home.scss']
})



export class Home implements OnInit {

  categories: any[] = [];

  featuredProducts: any[] = [];

  loading = true;

    apiUrl =
      'https://lazzaro-api1.onrender.com';
  settings: any;

  constructor(
    private http: HttpClient,
    private cdr: ChangeDetectorRef
  ) { }

  ngOnInit() {

    this.loadCategories();

    this.loadFeaturedProducts();

    this.loadSettings();
  }
loadSettings() {

  this.http.get<any>(
    `${this.apiUrl}/api/settings`
  )

  .subscribe({

    next: (res) => {

      console.log('Settings:', res);

      this.settings = res;

      this.cdr.detectChanges();
    },

    error: (err) => {

      console.log(err);
    }
  });
}
  loadCategories() {

    this.http.get<any[]>(
      `${this.apiUrl}/api/categories`
    )

    .subscribe({

      next: (res) => {

        this.categories = res;

        this.loading = false;

        this.cdr.detectChanges();
      },

      error: (err) => {

        console.log(err);

        this.loading = false;

        this.cdr.detectChanges();
      }
    });
  }

  loadFeaturedProducts() {

    this.http.get<any[]>(
      `${this.apiUrl}/api/products`
    )

    .subscribe({

      next: (res) => {

        this.featuredProducts =
          res.filter(x => x.featured);

        this.cdr.detectChanges();
      },

      error: (err) => {

        console.log(err);
      }
    });
  }
}